import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';

export const checkEmailSendTimestampRule: ValidatorFn = (control: AbstractControl): ValidationErrors | null => {
	const emailSendTimestamp = control.get('emailSendTimestamp')!.value;
	const emailReceipt = control.get('emailReceipt')!.value;

	return !!emailSendTimestamp && !emailReceipt ? { checkEmailRecipientFlag: true } : null;
};
